module.exports = __webpack_public_path__ + "img/haoyou.0d9cd866.png";